import { Link } from 'react-router-dom';
import { sourcePath } from '../lib/routing';

interface Props {
  rowId: number;
  opstina: string;
  bm: string;
  variant?: 'link' | 'static';
}

/**
 * Shows "[red N, opština, BM X]" attribution.
 * When variant="link" (default), clicks navigate to the source page.
 */
export default function AttributionBadge({ rowId, opstina, bm, variant = 'link' }: Props) {
  const label = `red ${rowId}, ${opstina}${bm ? `, BM ${bm}` : ''}`;
  if (variant === 'static') {
    return <span className="font-mono text-xs text-neutral-500">[{label}]</span>;
  }
  return (
    <Link
      to={sourcePath(rowId)}
      className="font-mono text-xs text-neutral-500 transition-colors hover:text-ink hover:underline"
    >
      [{label}]
    </Link>
  );
}
